import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

export const TypographyStyled = styled(Typography)({
  textDecoration: 'underline',
  textWrap: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const BoxStyled = styled(Box)({
  position: 'relative',
  gap: '4px',
  display: 'flex',
  alignItems: 'center',
});
